import isNumber from "lodash/isNumber";
import Series, { parseSeries } from "views/logic/aggregationbuilder/Series";
import SeriesConfig from "views/logic/aggregationbuilder/SeriesConfig";
import { thresholdsSupportedVisualizations } from "views/Constants";
import MetricsConfiguration from "./MetricsConfiguration";
const hasErrors = (errors) => errors.filter((error) => Object.keys(error).length > 0).length > 0;
const validateMetrics = (values) => {
  const errors = {};
  if (!values.metrics) {
    return errors;
  }
  const metricsErrors = values.metrics.map((metric) => {
    var _a;
    const metricError = {};
    if (!metric.function) {
      metricError.function = "Function is required.";
    }
    const isFieldRequired = metric.function !== "count" && (metric.function !== "percentage" || metric.strategy === "SUM");
    if (isFieldRequired && !metric.field) {
      metricError.field = `Field is required for function ${metric.function}.`;
    }
    if (metric.function === "percentile" && !metric.percentile) {
      metricError.percentile = "Percentile is required.";
    }
    if (metric.name && values.metrics.filter(({ name }) => name === metric.name).length > 1) {
      metricError.name = "Name must be unique.";
    }
    const thresholdErrors = (_a = metric == null ? void 0 : metric.thresholds) == null ? void 0 : _a.map((threshold) => {
      if (!isNumber(threshold == null ? void 0 : threshold.value)) return { value: "Threshold value is required." };
      return void 0;
    });
    if (thresholdErrors == null ? void 0 : thresholdErrors.filter((thresholdError) => !!(thresholdError == null ? void 0 : thresholdError.value)).length) {
      metricError.thresholds = thresholdErrors;
    }
    return metricError;
  });
  return hasErrors(metricsErrors) ? { metrics: metricsErrors } : {};
};
const parameterForMetric = (metric) => {
  switch (metric.function) {
    case "percentage":
      return metric.strategy;
    case "percentile":
      return metric.percentile;
    default:
      return void 0;
  }
};
const emptyToUndefined = (s) => (s == null ? void 0 : s.trim()) === "" ? void 0 : s;
const metricsToSeries = (formMetrics, visualization) => formMetrics.map(
  (metric) => Series.create(metric.function, emptyToUndefined(metric.field), parameterForMetric(metric)).toBuilder().config(
    SeriesConfig.empty().toBuilder().name(metric.name).thresholds(
      (metric == null ? void 0 : metric.showThresholds) && thresholdsSupportedVisualizations.includes(visualization.type) ? metric.thresholds : null
    ).build()
  ).build()
);
export const seriesToMetrics = (series) => series.map((s) => {
  var _a, _b, _c;
  const { type: func, field, percentile, strategy } = (_a = parseSeries(s.function)) != null ? _a : {};
  const metric = {
    function: func,
    field,
    name: (_b = s.config) == null ? void 0 : _b.name,
    thresholds: s.config.thresholds,
    showThresholds: !!((_c = s.config.thresholds) == null ? void 0 : _c.length)
  };
  if (percentile) {
    const parsedPercentile = Number.parseFloat(percentile);
    return {
      ...metric,
      percentile: parsedPercentile
    };
  }
  if (strategy) {
    return {
      ...metric,
      strategy
    };
  }
  return metric;
});
const MetricElement = {
  sectionTitle: "Metrics",
  title: "Metric",
  key: "metrics",
  order: 2,
  allowCreate: () => true,
  fromConfig: (config) => ({
    metrics: seriesToMetrics(config.series)
  }),
  toConfig: (formValues, configBuilder) => configBuilder.series(metricsToSeries(formValues.metrics, formValues.visualization)),
  onRemove: (index, formValues) => ({
    ...formValues,
    metrics: formValues.metrics.filter((_value, i) => index !== i)
  }),
  component: MetricsConfiguration,
  validate: validateMetrics,
  isEmpty: (formValues) => (formValues != null ? formValues : []).length === 0
};
export default MetricElement;
